module.exports = __webpack_public_path__ + "static/media/Upper-Body-&-Abs.2aaba52f.jpeg";